import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Footer.css';

const Footer = () => {
  const { isAuthenticated, preferences } = useAuth();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-copyright">
          <div className="footer-brand">
            <img src="/logo.jpeg" alt="ReadTheWord Logo" className="footer-logo" />
            <p className="footer-text">
              &copy; {new Date().getFullYear()} ReadTheWord
            </p>
          </div>
          <div className="footer-links">
            <Link to="/about" className="footer-link">The 2026 reading</Link>
            {isAuthenticated && preferences?.competitiveMode && (
              <Link to="/leaderboard" className="footer-nav-link">
                🏆 Leaderboard
              </Link>
            )}
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
            <a 
              href="https://saltmarshdigital.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              Powered by Saltmarsh Digital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
